import { Amplify } from 'aws-amplify';
import { logger } from '../utils/logger';

export const configureAmplify = () => {
  try {
    const isDev = import.meta.env.DEV;
    const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

    // Callback URLs must match exactly what's configured in Cognito
    // In Amplify v6, these must be arrays containing all allowed URLs
    // The first URL in the array will be used as the default redirect
    const redirectSignIn = isDev
      ? ['http://localhost:5173/auth/callback']
      : ['https://portal.cacxi.com.au/auth/callback'];
    const redirectSignOut = isDev
      ? ['http://localhost:5173/logout']
      : ['https://portal.cacxi.com.au/logout'];

    const config = {
      Auth: {
        Cognito: {
          region: import.meta.env.VITE_AWS_REGION,
          userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
          userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID,
          loginWith: cognitoDomain
            ? {
                oauth: {
                  domain: cognitoDomain,
                  scopes: ['openid', 'email', 'profile', 'phone'],
                  redirectSignIn,
                  redirectSignOut,
                  responseType: 'code' as const,
                },
              }
            : undefined,
        },
      },
    };

    // Validate required configuration
    const { region, userPoolId, userPoolClientId } = config.Auth.Cognito;
    if (!region || !userPoolId || !userPoolClientId) {
      throw new Error('Missing required AWS Cognito configuration');
    }

    Amplify.configure(config);
    logger.info('AWS Amplify configured successfully');

    if (cognitoDomain) {
      logger.info('OAuth configured with domain:', cognitoDomain);
      logger.info('Redirect Sign In:', redirectSignIn);
      logger.info('Redirect Sign Out:', redirectSignOut);
    }
  } catch (error) {
    logger.error('Failed to configure AWS Amplify:', error);
    throw error;
  }
};
